import styled from "styled-components";

export const CompanyDataContainer = styled.div.attrs({
})`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const WrapperContainer = styled.div.attrs({
})`
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 720px;
`;
export const CloseContainer = styled.div.attrs({
})`
    background: ${p => p.$sticky ? p.theme.palette.colors.backgroundSoft : p.theme.palette.colors.backgroundTransparent};
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 24px;
    width: 100%;
    padding-bottom: 24px;
    border-bottom: 1px solid ${p => p.theme.palette.colors.borderSoft};
    position: ${p => p.$sticky ? 'sticky' : 'static'};
    top: ${p => p.$sticky ? '-32px' : 'auto'};
    z-index: ${p => p.$sticky ? 4 : 'auto'};

    ${p => p.$sticky ? `
        margin: -32px -32px 0;
        padding: 32px 32px 24px;
    ` : ''}

    @media (max-width: 767px) {
        gap: 16px;
        padding-bottom: 18px;
    }

    @media (max-width: 1000px) {
        top: ${p => p.$sticky ? '-24px' : 'auto'};

        ${p => p.$sticky ? `
            margin: -24px -24px 0;
            padding: 24px 24px 18px;
        ` : ''}
    }

    @media (max-width: 480px) {
        top: ${p => p.$sticky ? '-18px' : 'auto'};

        ${p => p.$sticky ? `
            margin: -18px -18px 0;
            padding: 18px;
        ` : ''}
    }
`;
export const ModalTitle = styled.div.attrs({
})`
    font-family: Lato;
    font-size: 36px;
    line-height: 1;
    font-style: normal;
    font-weight: 700;
    letter-spacing: -0.04em;
    color: ${p => p.theme.palette.colors.text};
    @media (max-width: 991px) {
        font-size: 30px;
    }

    @media (max-width: 767px) {
        font-size: 24px;
    }
`;

export const ModalText = styled.div.attrs({
})`
    font-family: Lato;
    font-size: 15px;
    line-height: 1.55;
    font-style: normal;
    font-weight: 500;
    color: ${p => p.theme.palette.colors.muted};
    max-width: 60ch;
`;

export const CloseButton = styled.div.attrs({
})`
    width: 52px;
    min-width: 52px;
    height: 52px;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;

    &:hover {
        transform: translateY(-1px);
        background: ${p => p.theme.palette.colors.badgeMuted};
        border-color: ${p => p.theme.palette.colors.shellGlow};
    }

    @media (max-width: 767px) {
        width: 44px;
        min-width: 44px;
        height: 44px;
        border-radius: 14px;
    }
`;
